exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".custom-collapse-icon .fa-chevron-up[data-v-1b54087b]{display:inline-block}.custom-collapse-icon.collapsed .fa-chevron-up[data-v-1b54087b],.custom-collapse-icon .fa-chevron-down[data-v-1b54087b]{display:none}.custom-collapse-icon.collapsed .fa-chevron-down[data-v-1b54087b]{display:inline-block}@media (min-width:768px){.modal-body[data-v-1b54087b]{overflow-y:auto;max-height:calc(100vh - 315px)}}", ""]);

// exports
